<template>
  <v-app id="onboarding">
    <component
      :is="this.$route.meta.layout || 'div'"
      v-bind="{ class: 'fill-height' }"
    >
     <router-view v-show="plateau==0"/>
     <div  v-show="plateau==1" id="plateau_ui_placeholder"></div>
    </component>
    <SimpleWarningDialog
      v-if="apiServiceErrorDialog"
      id="globalWarningDialog"
      ref="globalWarningDialog"
      :title="$t(globalDialogTitle)"
      :text="globalDialogText"
      :subtext="globalDialogSubText"
      @onPrimary="closeWarningDialog"
    />
  </v-app>
</template>

<script>

import SimpleWarningDialog from "./components/SimpleWarningDialog";
export default {
  components: { SimpleWarningDialog },
  data: () => ({
    plateau:0,
    
    apiServiceErrorDialog: false,
    globalDialogTitle: null,
    globalDialogText: null
  }),
 
  created() {
   

     this.$eventHub.$on("plateau", (val) => {
       this.plateau = val


     });
 
    window.addEventListener("mousemove", this.onMouseMove);
    //Generic Error Dialog
    this.$eventHub.$on("error-happened", this.handleError);
  },
  beforeDestroy() {
debugger;
    window.removeEventListener("mousemove", this.onMouseMove);
    this.$eventHub.$off("error-happened");
  },
  methods: {
   
    handleError(error) {
      this.globalDialogTitle = error.title
        ? this.$t(error.title)
        : this.$t("unexpectedErrorHappened");
      if (error.warningMessage == null) {
        this.globalDialogText = this.$t("errorCode") + " : " + error.id;
        this.globalDialogSubText =
          this.$t("errorDescription") +
          " : " +
          (error.responseMessage != null ? this.$t(error.responseMessage) : "");
      } else {
        this.globalDialogText = error.warningMessage;
        this.globalDialogSubText = error.warningDescription != null ? error.warningDescription : null;
      }
      this.apiServiceErrorDialog = true;
    },
    closeWarningDialog() {
      this.apiServiceErrorDialog = false;
    },
    onMouseMove(event) {
      this.$clearCountdown();
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/styles.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue